import { useState } from "react";
import {
  Grid,
  IconButton,
  TextField,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import callPiggybackAPI from "../Helpers/piggyback.api.helper";
import { toast } from "react-toastify";

export default function StoreSettings({ selectedSite, open, onClose }) {
  const [schemaName, setSchemaName] = useState("");
  const [fields, setFields] = useState([]);

  const addField = () => setFields([...fields, { name: "", type: "text" }]);
  const updateField = (idx, updated) => {
    const newFields = [...fields];
    newFields[idx] = { ...newFields[idx], ...updated };
    setFields(newFields);
  };
  const deleteField = (idx) => setFields(fields.filter((_, i) => i !== idx));

  const handleSave = async () => {
    if (!schemaName) {
      toast.error("Schema Name is required");
      return;
    }

    const body = {
      tenantId: selectedSite.tenantId,
      siteId: selectedSite.id,
      name: schemaName,
      fields: fields.reduce((acc, f) => {
        if (!f.name) return acc;

        let defaultValue;
        switch (f.type) {
          case "text":
            defaultValue = "string";
            break;
          case "number":
            defaultValue = 0;
            break;
          case "array":
            defaultValue = [];
            break;
          default:
            defaultValue = "";
        }

        acc[f.name] = defaultValue;
        return acc;
      }, {}),
      customProperties: {},
    };

    try {
      await callPiggybackAPI("data-info", {}, body, "POST");
      toast.success("Schema saved successfully!");
      onClose();
    } catch (err) {
      console.error("Failed to save schema:", err);
      toast.error("Failed to save schema.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <strong>Add Schema</strong>
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <TextField
          label="Schema Name"
          value={schemaName}
          onChange={(e) => setSchemaName(e.target.value)}
          fullWidth
        />
        <Button variant="outlined" startIcon={<Add />} onClick={addField}>
          Add Field
        </Button>

        {fields.map((field, idx) => (
          <Grid container spacing={2} key={idx} alignItems="center">
            <Grid item xs={6}>
              <TextField
                label="Field Name"
                value={field.name}
                onChange={(e) => updateField(idx, { name: e.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={5}>
              <Select
                value={field.type}
                onChange={(e) => updateField(idx, { type: e.target.value })}
                fullWidth
              >
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="number">Number</MenuItem>
                <MenuItem value="array">Array</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => deleteField(idx)} size="small">
                <Delete fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
            color: "#fff",
            boxShadow: "none",
            "&:hover": {
              background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
              opacity: 0.95,
              boxShadow: "none"
            },
            "&.Mui-disabled": {
              background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
              opacity: 0.5,
              color: "#fff"
            }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            textTransform: "none",
            backgroundColor: "rgb(90, 28, 47)",
            "&:hover": {
              backgroundColor: "rgb(70, 20, 35)",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(90, 28, 47, 0.4)",
              color: "#fff",
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
